import _regenerator from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import request from "@/utils/request";

// 用户登录
export function login(data) {
  return request({
    url: "/api/oauth/Login",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    data: data
  });
}
//微信 用户登录
export function loginwx(data) {
  return request({
    url: "/api/BasicData/WeChat/Login",
    method: "post",
    data: data
  });
}

// 获取当前用户信息
export function getInfo() {
  return _getInfo.apply(this, arguments);
}

// 退出登录
function _getInfo() {
  _getInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, request({
            url: "/api/oauth/CurrentUser",
            method: "get"
          }));
      }
    }, _callee);
  }));
  return _getInfo.apply(this, arguments);
}
export function logout() {
  return request({
    url: "/api/oauth/Logout",
    method: "get"
  });
}

// 锁屏解锁登录
export function unlock(data) {
  return request({
    url: "/api/oauth/LockScreen",
    method: "post",
    data: data
  });
}